module.exports = __webpack_public_path__ + "img/17336058.cac787ae.png";